import "./AsesoresPage.css";
import NuestrosAsesores from "../components/home/NuestrosAsesores";
import Ofrecemos from "../components/home/Ofrecemos";
import Steps from "../components/home/Steps";
import Review from "../components/home/Review";
import Banner from "../components/home/Banner";

const IntroAsesores = () => {
  return (
    <div className="intro-asesores">
      {/* Text section */}
      <div className="intro-asesores-text">
        <h2 className="intro-asesores-heading">
          Conoce a los asesores que te ayudan a transportar tu vehículo sin que
          manejes
        </h2>
        <p className="intro-asesores-description">
          Asesores <span>verificados</span>, atención directa por{" "}
          <span>WhatsApp</span>.
        </p>
      </div>

      {/* Image section */}
      <div className="intro-asesores-image">
        <img
          src="/images/intro-asesores.png"
          alt="Asesor con vehículos"
        />
      </div>
    </div>
  );
};

export default function AsesoresPage() {
  return (
    <>
      <IntroAsesores />
      <NuestrosAsesores />
      <Ofrecemos />
      <Steps />
      <Review />
      <Banner />
    </>
  );
}
